import React, { Component } from 'react';
import ReactEcharts from 'echarts-for-react';
import './styles.css';

class Chart extends Component {
	render() {
		return (
			<div className="chart">
				<ReactEcharts {...this.props} />
			</div>
		);
	}
}

export default Chart;
